<template>
  <section id="toxicology_report_page">
    <div v-loading.fullscreen.lock="loading"></div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      data: {},
      loading: false,
      reportData: null,
      testCategories: [],
      testReportURL: false,
      showTestReport: false,
    };
  },
  computed: {
    ...mapGetters("cases", [
      "getSampleNameTestResultData",
      "getCaseInformation",
    ]),
    caseId() {
      return this.$route.params.case_id;
    },
  },

  async mounted() {
    await this.fetchData();
    this.toggleBodyClass("addClass", "covid-page");
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/fetchSampleNameTestResultsData", {
          case_id: this.caseId,
        });

        if (
          this.getSampleNameTestResultData.data &&
          this.getSampleNameTestResultData.data.type == "application/pdf"
        ) {
          const arrayBuffer = this.getSampleNameTestResultData.data.data.data;
          const pdfBuffer = new Uint8Array(arrayBuffer);
          var blob = new Blob([pdfBuffer], { type: "application/pdf" });
          var blobURL = URL.createObjectURL(blob);
          let iframe =
            "<iframe src='" + blobURL + "' style='height:100%;width:100%'/>";
          // window.location.href = blobURL;
          document.write(iframe);
        } else {
          document.write(this.getSampleNameTestResultData.data);
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  unmounted() {
    this.toggleBodyClass("removeClass", "covid-page");
  },
  components: {},
};
</script>

<style lang="scss">
#toxicology_report_page {
  width: 900px;
  margin: 0 auto;
  font-size: 15px;
  .action-block {
    margin: 20px 0;
    .el-button {
      font-size: 1rem;
      text-transform: uppercase;
      letter-spacing: 2px;
      font-weight: 600;
    }
  }
  .report-container {
    thead {
      tr {
        th {
          background: none !important;
          border-bottom: none;
        }
      }
    }
  }

  .w-100 {
    width: 100%;
  }

  thead {
    display: table-header-group;
  }

  tfoot {
    display: table-row-group;
  }

  tr {
    page-break-inside: avoid;
  }
}

#header-information {
  padding-bottom: 5px;

  .w-100 {
    width: 100%;
  }

  .logo {
    max-width: 250px;
    float: right;
  }

  .report-name {
    font-size: 1.75em;
    font-weight: 400;
    color: #333;
    text-align: left;
    font-family: "Montserrat", sans-serif;
  }

  .address-information {
    margin-top: 0;
    position: relative;
    text-align: left;

    p {
      font-size: 13px;
    }

    &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -10px;
      height: 1.5px;
      width: 100%;
      background: #2b5e76;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap;

      li {
        display: grid;
        align-items: center;
        grid-template-columns: 20px auto;
        column-gap: 5px;
        margin-bottom: 8px;

        &:not(:last-child) {
          margin-right: 15px;
        }

        .icon {
          img {
            width: 20px;
            margin-bottom: -5px;
          }
        }

        p {
          margin: 0;
          padding: 0;
          font-weight: 400;
          line-height: 22px;
          font-family: "Lato", sans-serif;
          color: #000;
        }
      }
    }
  }
}

#report-body-information {
  .patient-information-block {
    margin-top: 20px;
  }

  .patient-information-block {
    td {
      padding: 10px 10px !important;
      vertical-align: top;

      &:not(:last-child) {
        border-right: 1px solid #c2c2c2 !important;
      }
    }

    .title {
      font-size: 1.2em;
    }

    .patient-details {
      border: 1px solid #c2c2c2;
      background: #ecf7fa;
    }

    .patient-details {
      td {
        vertical-align: top;
      }

      p {
        margin: 0;
        margin-bottom: 5px;
        line-height: 20px;
        color: #333;
        font-size: 0.95em;
        font-family: "Lato", sans-serif;
        display: flex;
      }

      p {
        .line-name {
          width: 50%;
          display: inline-block;
          position: relative;

          &:after {
            content: ":";
            position: absolute;
            right: 10px;
            top: 0;
          }
        }
        .line-value {
          width: 50%;
        }
      }
    }
  }
}

#confirmation-results {
  margin-top: 30px;

  h4 {
    font-size: 1.15em;
    color: #333333;
    font-weight: 600;
    font-family: "Montserrat", sans-serif;
    margin-bottom: 10px;
    margin-top: 0;
  }

  .confirmation-table-heading {
    td {
      padding: 15px 10px;
      color: #333333;
      font-size: 14px;
      font-family: "Lato", sans-serif;

      &:nth-child(1) {
        width: 250px;
        padding-left: 15px !important;
        font-weight: 600;
      }

      &:nth-child(2) {
        width: 165px;
      }

      &:nth-child(3) {
        width: 180px;
      }

      &:nth-child(4) {
        width: 160px;
      }

      &:nth-child(5) {
        width: 170px;
        padding-right: 20px;
      }
    }
  }
  .confirmation-table-heading.type2 {
    td {
      padding: 15px 10px;
      color: #333333;
      font-size: 14px;
      font-family: "Lato", sans-serif;
      &:nth-child(1) {
        width: 180px;
      }

      &:nth-child(2) {
        width: 100px;
      }

      &:nth-child(3) {
        width: 150px;
      }

      &:nth-child(4) {
        width: 135px;
      }

      &:nth-child(5) {
        width: 120px;
        text-align: left;
      }

      &:nth-child(6) {
        width: 130px;
      }
    }
  }

  .each-result {
    &:not(:last-child) {
      margin-bottom: 15px;
    }

    .table-heading {
      background: #e3f5f9;
      color: #184f68;
      font-size: 1em;
      font-family: "Montserrat", sans-serif;
      font-weight: 600;
      letter-spacing: 0.5px;
      padding: 5px 15px;
      margin: 0;
      border-left: 1px solid #dedede;
      border-right: 1px solid #dedede;
    }

    table {
      border-collapse: collapse;
      tr {
        border: 1px solid #dedede;
        border-top-color: #efefef;
        border-bottom-color: #efefef;
        &:nth-child(even) {
          background-color: #f8fbffa9;
        }

        td {
          padding: 7px !important;
          color: #333333;
          font-size: 14px;
          font-family: "Lato", sans-serif;

          &:nth-child(1) {
            width: 200px;
            padding-left: 15px !important;
            font-weight: 600;
          }

          &:nth-child(2) {
            width: 120px;
            text-align: right;
            padding-right: 20px !important;
          }

          &:nth-child(3) {
            width: 200px;
            text-align: center;
          }

          &:nth-child(4) {
            width: 160px;
          }

          &:nth-child(5) {
            width: 150px;
            padding-right: 20px;
          }

          &.red {
            color: #ff3c58;
          }
        }
      }
    }
  }
  .type-2 {
    .each-result {
      background-color: #f9f9ff;
      .table-heading {
        background: #e2ebf3;
        color: #0058a7;
        border-left: 2px solid #a6c1d4;
        border-right: 2px solid #a6c1d4;
      }
      table {
        tr {
          border: 2px solid #a6c1d4;
          td {
            &:nth-child(1) {
              width: 180px;
            }

            &:nth-child(2) {
              width: 100px;
              text-align: right;
              padding-right: 20px !important;
            }

            &:nth-child(3) {
              width: 150px;
            }

            &:nth-child(4) {
              width: 135px;
            }

            &:nth-child(5) {
              width: 120px;
              text-align: left;
            }

            &:nth-child(6) {
              width: 130px;
            }
          }
        }
      }
    }
  }
}
.medications-table {
  border: 1px solid #dedede;
  padding: 12px;
  border-radius: 4px;
  h4 {
    padding-left: 7px;
  }
}
#confirmation-results1 {
  margin-top: 30px;
  margin-bottom: 50px;

  h4 {
    font-size: 1.15em;
    color: #333333;
    font-weight: 600;
    font-family: "Montserrat", sans-serif;
    margin-bottom: 10px;
    margin-top: 0;
  }
  .table-headings-results1 {
    tbody {
      tr {
        td {
          padding: 10px !important;
          color: #333333;
          font-size: 14px;
          font-family: "Lato", sans-serif;

          &:nth-child(1) {
            width: 250px;
            padding-left: 15px !important;
            font-weight: 600;
          }

          &:nth-child(2) {
            width: 165px;
            text-align: right;
            padding-right: 20px !important;
          }

          &:nth-child(3) {
            width: 180px;
          }

          &:nth-child(4) {
            width: 160px;
          }

          &:nth-child(5) {
            width: 170px;
            padding-right: 20px;
          }
        }
      }
    }

    .confirmation-table-heading {
      td {
        padding: 15px 10px;
        color: #333333;
        font-size: 14px;
        font-family: "Lato", sans-serif;

        &:nth-child(1) {
          width: 250px;
          padding-left: 15px !important;
          font-weight: 600;
        }

        &:nth-child(2) {
          width: 165px;
        }

        &:nth-child(3) {
          width: 180px;
        }

        &:nth-child(4) {
          width: 160px;
        }

        &:nth-child(5) {
          width: 170px;
          padding-right: 20px;
        }
      }
    }

    .each-result {
      &:not(:last-child) {
        margin-bottom: 15px;
      }

      .table-heading {
        background: #e3f5f9;
        color: #184f68;
        font-size: 1em;
        font-family: "Montserrat", sans-serif;
        font-weight: 600;
        letter-spacing: 0.5px;
        padding: 5px 15px;
        margin: 0;
      }

      table {
        border-collapse: collapse;

        tr {
          border: 1px solid #dedede;

          td {
            padding: 10px !important;
            color: #333333;
            font-size: 14px;
            font-family: "Lato", sans-serif;

            &:nth-child(1) {
              width: 250px;
              padding-left: 15px !important;
              font-weight: 600;
            }

            &:nth-child(2) {
              width: 165px;
            }

            &:nth-child(3) {
              width: 180px;
            }

            &:nth-child(4) {
              width: 160px;
            }

            &:nth-child(5) {
              width: 170px;
              padding-right: 20px;
            }

            &.red {
              color: #ff3c58;
            }
          }
        }
      }
    }
  }
  .medications-table {
    border: 1px solid black;
    padding: 12px;

    border-radius: 4px;
    h4 {
      padding-left: 7px;
    }
  }
  .confirmation-passitive-title {
    margin-top: 20px;
  }
  .type-2 {
    .each-result {
      table {
        tr {
          border: 1px solid #dedede;

          td {
            &:nth-child(1) {
              width: 180px;
            }

            &:nth-child(2) {
              width: 100px;
              padding-right: 20px !important;
            }

            &:nth-child(3) {
              width: 150px;
            }

            &:nth-child(4) {
              width: 135px;
            }

            &:nth-child(5) {
              width: 120px;
              text-align: left;
            }

            &:nth-child(6) {
              width: 130px;
            }
          }
        }
      }
    }
  }

  .screen-validity {
    margin-top: 30px;
    margin-bottom: 20px;

    h4 {
      font-size: 1.15em;
      color: #333333;
      font-weight: 600;
      font-family: "Montserrat", sans-serif;
      margin-bottom: 15px !important;
      margin-top: 0;
    }

    table {
      border-collapse: collapse;

      thead {
        tr {
          background: #e3f5f9;

          th {
            padding: 5px 10px !important;
            font-family: "Montserrat", sans-serif;
            color: #184f68;
            font-weight: 500;
            font-size: 15px;
            text-align: left;
          }
        }
      }

      tbody {
        tr {
          border: 1px solid rgba(239, 239, 239, 0.5);
        }

        td {
          padding: 10px !important;
          color: #333333;
          font-size: 14px;
          font-family: "Lato", sans-serif;
        }
      }
    }
  }

  .description {
    margin-top: 30px;

    p {
      line-height: 22px;
      margin: 3px 0;
    }
  }

  // Footer Information
  #report-footer-information {
    .footer-report-number {
      h3 {
        background: #e5f5fb;
        padding: 4px 10px;
        font-size: 1.3em;
        color: #2b5e76;
        font-weight: normal;
        margin-bottom: 25px;
      }
    }

    .footer-table {
      tr {
        td {
          &:nth-child(1) {
            width: 80%;
          }

          p {
            line-height: 20px;
          }

          .footer-company-logo {
            margin-left: 60px;

            img {
              width: 120px;
            }
          }
        }
      }
    }
  }

  //
  @media print {
    #toxicology_report_page {
      padding: 40px !important;

      #report-body-information {
        .patient-information-block {
          margin-top: -50px !important;
        }
      }

      .header-info {
        position: fixed;
        top: 40px;
        left: 50px;
        right: 50px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.25);
      }

      .footer-info {
        background: #fff;
        height: 150px;
        position: fixed;
        bottom: 40px;
        left: 40px;
        right: 40px;
      }

      .body-info {
        position: relative;
        width: 100%;
        top: 210px;
        left: 0;
        right: 0;
        overflow: visible !important;
      }

      .assay-tested-result {
        page-break-before: always;
      }

      .antibiotic-resistance {
        page-break-before: always;
      }

      .microorganisms {
        page-break-before: always;
      }

      .next-page {
        page-break-before: always;
      }
    }

    .screen-validity {
      margin-top: 0;
      margin-bottom: 20px;
    }

    .description {
      margin-top: 0;
    }
  }
}

#confirmation-results {
  &.table-type2 {
    .each-result {
      table {
        border-radius: 0;
        tr:first-child {
          td {
            background: #e3f5f9;
            color: #184f68;
            font-size: 1em;
            font-family: "Montserrat", sans-serif;
            font-weight: 400;
            padding: 5px 15px;
          }
        }
      }
    }
  }
}
thead tr td {
  font-weight: 600 !important;
}
</style>
